<section>
    <div class="max-w-7xl mx-auto py-12 px-4">
  <div class="flex flex-col items-center justify-center space-y-6">

    <div class="text-center group">
      <p class="text-2xl md:text-4xl font-extrabold text-slate-800 flex items-center justify-center gap-3">
        <i class="fab fa-whatsapp text-green-500 text-3xl md:text-5xl animate-bounce"></i>

        <span>সাপোর্ট হোয়াটসঅ্যাপঃ
          <span class="relative inline-block text-green-600">
            01688667870
            <span class="absolute bottom-0 left-0 w-full h-1 bg-amber-500 rounded-full"></span>
          </span>
        </span>
      </p>
    </div>

    <a routerLink="/tutorial-videos"
       class="flex items-center gap-3 px-8 py-3 bg-[#1a237e] text-white font-bold rounded-lg hover:bg-blue-800 transition-all duration-300 shadow-lg hover:shadow-blue-200 active:scale-95 group">

      <i class="fas fa-play-circle text-xl group-hover:scale-120 transition-transform"></i>

      <span class="text-lg">টিউটোরিয়াল ভিডিও দেখুন</span>

      <i class="fas fa-arrow-right ml-2 opacity-70 group-hover:translate-x-1 transition-transform"></i>
    </a>

  </div>
</div>
<app-video-showcase-section></app-video-showcase-section>
<app-supprots-ai-help-desk></app-supprots-ai-help-desk>
<app-support-desk></app-support-desk>
<app-eduman-customer-support></app-eduman-customer-support>
<app-support-faq></app-support-faq>
<app-slide-logo-item></app-slide-logo-item>


</section>

